import React from 'react';
import { Dialog, DialogContent, DialogActions, Button, Box, Typography } from '@mui/material';
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';
import { PARTNER_BRAND } from '../../partnerDashboardTheme';

const ArchiveCommunityDialog = ({ open, communityName, archiving = false, onClose, onConfirm }) => (
  <Dialog
    open={open}
    onClose={archiving ? undefined : onClose}
    PaperProps={{
      sx: {
        borderRadius: 2,
        p: 2,
        textAlign: 'center',
        maxWidth: 400,
        width: '100%',
      },
    }}
  >
    <DialogContent sx={{ pb: 1, pt: 1 }}>
      <Box
        sx={{
          width: 60,
          height: 60,
          borderRadius: '50%',
          bgcolor: (theme) => theme.portal?.accentSoft ?? theme.palette.action.hover,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mx: 'auto',
          mb: 2,
        }}
      >
        <ArchiveOutlinedIcon sx={{ fontSize: 32, color: PARTNER_BRAND }} />
      </Box>
      <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
        Archive Community?
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
        Archive{' '}
        <Box component="span" sx={{ fontWeight: 600, color: 'text.primary' }}>
          {communityName || 'this community'}
        </Box>
        ? Members will no longer be able to join or interact in this community. You can restore it
        later from archived communities.
      </Typography>
    </DialogContent>
    <DialogActions sx={{ justifyContent: 'center', gap: 2, pb: 1, pt: 2 }}>
      <Button
        variant="outlined"
        disabled={archiving}
        onClick={onClose}
        sx={{
          minWidth: 120,
          height: 44,
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 1.5,
          color: PARTNER_BRAND,
          borderColor: PARTNER_BRAND,
          '&:hover': {
            borderColor: 'primary.dark',
            bgcolor: 'rgba(224, 104, 10, 0.04)',
          },
        }}
      >
        Cancel
      </Button>
      <Button
        variant="contained"
        disabled={archiving}
        onClick={onConfirm}
        sx={{
          minWidth: 120,
          height: 44,
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 1.5,
          bgcolor: PARTNER_BRAND,
          boxShadow: 'none',
          '&:hover': {
            bgcolor: 'primary.dark',
            boxShadow: 'none',
          },
        }}
      >
        {archiving ? 'Archiving…' : 'Archive'}
      </Button>
    </DialogActions>
  </Dialog>
);

export default ArchiveCommunityDialog;
